import { defineAsyncComponent, markRaw } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";

export const tileConfigs: TileConfigType = {
  PowerBITile: {
    active: true,
    settingsModule: markRaw(
      defineAsyncComponent(() => import("./components/PowerBITileSettings.vue")),
    ),
    component: markRaw(defineAsyncComponent(() => import("./components/PowerBITile.vue"))),
    icon: "fas fa-chart-simple",
  },
};
